import { Button, Skeleton } from '@teach/ui'
import { useTopUp } from '@/features/ai/credits/CreditsDialogContext'
import { useCreditsDisplay } from '@/components/layout/sidebar/useCreditsDisplay'
import { formatCredits, formatCreditsWithWord } from '@/features/ai/lib/money'
import coins from '@/assets/loader/flower.svg'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Карточка кредитов: остаток и покупка, стопка монет выглядывает из угла.
 *  Доли «от максимума» нет: сервер не отдаёт сумму последней покупки. */
export const CreditsCard = () => {
  const { open: openTopUp } = useTopUp()
  const { balance, held, unavailable, shownBalance } = useCreditsDisplay()
  const m = useMessages(messages)

  return (
    <div className="relative flex min-h-[168px] flex-col justify-between overflow-hidden rounded-2xl bg-foreground/5 p-5">
      <div className="relative z-10">
        <div className="text-sm text-muted-foreground">{m.balance}</div>
        <div className="mt-1 min-w-0">
          {unavailable ? (
            <p className="text-2xl font-semibold">—</p>
          ) : balance ? (
            <p className="text-2xl font-semibold">{formatCreditsWithWord(shownBalance)}</p>
          ) : (
            <Skeleton className="h-8 w-40" />
          )}
          {held ? (
            <p className="mt-1 text-sm text-muted-foreground">{m.held(formatCredits(held))}</p>
          ) : null}
        </div>
      </div>
      <img
        src={coins}
        alt=""
        aria-hidden="true"
        draggable={false}
        className="pointer-events-none absolute bottom-4 right-4 size-24"
      />
      <Button className="relative z-10 self-start" onClick={() => openTopUp(null, 'packages')}>
        {m.topUp}
      </Button>
    </div>
  )
}
